module.exports = __webpack_public_path__ + "static/media/refer.13228041.png";